/**
 * GROW-443
 * Quick workaround for topic's custom meta description,
 * Remove it after backend implementation https://bravado-network.atlassian.net/browse/GROW-447
 */
const SLUG_DESCRIPTION: Record<string, string> = {
  'shit-prospects-think-salespeople-do-everyday':
    'Find out the evil and malicious reasons prospects think salespeople call them on the phone every day with Bravado’s satirical daily sales schedule',
};

export default (slug: string): string | undefined => {
  return SLUG_DESCRIPTION[slug];
};
